import { SwiperSlide } from "swiper/react";

import SwiperSlider from "./SwiperSlider";
import TranslatedMessage from "./TranslatedMessage";
import TestimonialData from "../variables/variables.json";

const Testimonial = (props) => {
	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;

	return (
		<SwiperSlider>
			{TestimonialData.miasta[propsMiasto].testimonial.map((testimonial, index) => (
				<SwiperSlide key={index}>
					<div className="testimonial__container">
						<h3 className="testimonial__title">
							<TranslatedMessage id={testimonial.who} />
						</h3>
						<blockquote className="testimonial__blockquote">
							<TranslatedMessage id={testimonial.opinion} />
						</blockquote>
					</div>
				</SwiperSlide>
			))}
		</SwiperSlider>
	);
};

export default Testimonial;
